import './toast.less'
//
import React from 'react';
import ReactDom from 'react-dom';
import $ from 'jquery'
import classnames from 'classnames';
import tools from '../libs/tools'
//
import Component from '../core/component';
import Enhance from '../core/enhance';
//
import Lang from '../common/lang';

let showDom = null;

/**
 *
 */
class Toast extends Component {
    
    state = {
        show: false,
        title: null,
    }
    
    constructor(props, context) {
        super(props, context);
        
        if (!showDom) {
            showDom = $(`<div id="${tools.uuid()}"></div>`)[0];
            $(document.body).append(showDom)
        }
    }
    
    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        window.toast = this._handlerToast;
        window.Toast = this._handlerToast;
    }
    
    
    /**
     * 卸载
     */
    componentWillUnmount() {
    }
    
    /**
     *
     * @returns {XML}
     */
    render() {
        return ReactDom.createPortal(
            <div ref="toast" className={classnames("c-toast")}>
                <div className={classnames("c-toast-content animated fast", this.state.show ? 'zoomIn' : 'zoomOut')}>
                    {this.state.title ? <div className="c-toast-title">{this.state.title}</div> : null}
                </div>
            </div>, showDom
        );
    }
    
    
    /**
     *
     * @private
     */
    _handlerToast = (title) => {
        clearTimeout(this.timer1);
        clearTimeout(this.timer2);
        if (tools.is_string(title)) {
            this.setState({show: true, title: (<Lang lang={title}/>)});
        }
        else {
            this.setState({show: true, title});
        }
        this.timer1 = this.timeout(this._handlerHide1, 3000);
        this.timer2 = this.timeout(this._handlerHide2, 4000);
    }
    
    
    /**
     *
     * @private
     */
    _handlerHide1 = () => {
        this.setState({show: false});
    }
    
    /**
     *
     * @private
     */
    _handlerHide2 = () => {
        this.setState({title: null});
    }
    
    
    /**
     *
     * @private
     */
    _handlerAnimationEnd = () => {
    }
}

Enhance(Toast, {}, 'Toast');
export default Toast;
